import { Icon } from '@/app/components/Icon'
import { cn } from '@/app/utils/style'

type CheckListItemProps = {
  children: React.ReactNode
  size?: 'm' | 'l' | 'hero'
  classNames?: {
    root?: string
    icon?: string
    container?: string
    text?: string
  }
}

const sizes = {
  m: {
    container: 'size-[20px]',
    icon: 16,
  },
  l: {
    container: 'size-[30px]',
    icon: 22,
  },
  hero: {
    container: 'size-[25px]',
    icon: 20,
  },
}

export function CheckListItem({ children, size = 'm', classNames }: CheckListItemProps) {
  const sizeConfig = sizes[size]
  const iconName = size === 'l' ? 'faBadgeCheck' : size === 'hero' ? 'faCheck' : 'faCircleCheck'

  return (
    <li
      className={cn(
        'flex gap-sm [&_a]:text-white-950 [&_a]:underline',
        size === 'l' ? 'font-book' : 'font-normal',
        classNames?.root,
      )}
    >
      <span
        className={cn(
          'flex items-center justify-center rounded-full mt-[2px] shrink-0',
          sizeConfig.container,
          classNames?.container,
        )}
      >
        <Icon
          name={iconName}
          provider="fontawesome"
          style="regular"
          size={sizeConfig.icon}
          className={cn('text-green-200', size === 'l' && 'relative top-[-1px]', classNames?.icon)}
        />
      </span>
      <span className={cn('flex-1 self-center', classNames?.text)}>{children}</span>
    </li>
  )
}
